import { render, staticRenderFns } from "./DimensionsList.vue?vue&type=template&id=6a81ae98"
import script from "./DimensionsList.vue?vue&type=script&lang=js"
export * from "./DimensionsList.vue?vue&type=script&lang=js"
import style0 from "./DimensionsList.vue?vue&type=style&index=0&id=6a81ae98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports